export enum PageModeType {
	OK = "OK",
	PAGE_NOT_FOUND = "PAGE_NOT_FOUND",
	ACCESS_DENIED = "ACCESS_DENIED",
	INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR"
}
